import React, { useState, useEffect } from "react";
import SrFixationForm1 from "../FormsScale/srFixationForm1";
import SrFixationForm2 from "../FormsScale/srFixationForm2";
import SrFixationForm3 from "../FormsScale/srFixationForm3";
import SrFixationForm4 from "../FormsScale/srFixationForm4";
import SrFixationForm5 from "../FormsScale/srFixationForm5";
import SrFixationForm6 from "../FormsScale/srFixationForm6";

import { useFormSubmission } from "../../pages/payment/customPayment";
import Swal from 'sweetalert2';
import {
  handleFormDataChange,
  handleNextStep,
  handlePreviousStep,
  
} from "../../components/formHandlers"; 
import "../../../style/google_forms.css"; 





const SrScaleFixation = () => {

  const initialFormState = {
    //Form 1
    officeName: '',
    employeeName: '',
    email: '',
    phoneNumber: '',
    dateOfBirth: '',
    dateOfJoining: '',
    designation: '',

    //Form 2
    payBand: '',
    basicPay: '',
    seniorScale: '',
    gradePay: '',
    reasonChange: '',
    

    //Form 3
    payBandPrevious: '',
    designationPromotion: '',
    dateOfPromotion: '',
    dateOfOption: '',
    basicPayPrevious: '',
    notionalIncrement: '',
    payBandPromotion: '',

    //Form 4
    hasUnpaidLeave: '',
    unpaidLeaveDetails: '',
    hasServiceBreak: '',
    serviceBreakDetails: '',
    isServiceBreakCondoned: '',

    //Form 5
    trainingLocation: '',
    trainingDuration: '',

    //Form 6
    fixationTillDate: '',



  };
const dummyFormData = {
  uniqueFormId: "SRFIX-2025-0003",

  // फॉर्म 1: वैयक्तिक माहिती
  officeName: "जिल्हा परिषद माध्यमिक शाळा",
  employeeName: "राजेश शंकर पाटील",
  email: "rajesh.patil@gmail.com",
  phoneNumber: "9876543210",
  dateOfBirth: new Date("1978-06-15"),
  dateOfJoining: new Date("2005-07-01"),
  designation: "माध्यमिक शिक्षक",

  // फॉर्म 2: 01/01/2016 रोजीचे वेतन तपशील
  payBand: "PB2: 15600-39100",
  basicPay: 18750,
  seniorScale: "हो",
  gradePay: 5400,
  reasonChange: "वरिष्ठ वेतन श्रेणी लागू झाल्यामुळे",

  // फॉर्म 3: पदोन्नती तपशील
  payBandPrevious: "S-12",
  designationPromotion: "मुख्याध्यापक",
  dateOfPromotion: new Date("2018-07-01"),
  dateOfOption: new Date("2018-07-01"),
  basicPayPrevious: 20050,
  notionalIncrement: "हो",
  payBandPromotion: "S-15",

  // फॉर्म 4: सेवाखंड / रजा तपशील
  hasUnpaidLeave: "हो",
  unpaidLeaveDetails: "01/06/2020 ते 30/06/2020 - वैद्यकीय कारणास्तव विनावेतन रजा",
  hasServiceBreak: "हो",
  serviceBreakDetails: "01/01/2015 ते 31/03/2015 - अनधिकृत अनुपस्थिती",
  isServiceBreakCondoned: "नाही",

  // फॉर्म 5: प्रशिक्षण तपशील
  trainingLocation: "पुणे",
  trainingDuration: "१ महिना",

  // फॉर्म 6: वेतननिश्चिती वैधतेची तारीख
  fixationTillDate: new Date("2025-01-01")
};


  
  
 const [formData, setFormData] = useState(initialFormState);
   const { handleFormSubmission, isSubmitting, PaymentWindowComponent  } = useFormSubmission();
 
  
  const [step, setStep] = useState(1);

  const handleNext = () => {
    handleNextStep(setStep);
  };

  const handleBack = () => {
    handlePreviousStep(setStep);
  };


  const formConfig = {
    apiEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/srScaleFixation/submit-srScaleFixation`,
    paymentDescription: "Payment for Senior Scale Fixation Documents",
    successRoute: "/srScaleFixation/srScaleFixation-result",
    name: dummyFormData.employeeName,
    formType: "Senior College Scale Fixation",
    email: dummyFormData.email,
    contact: dummyFormData.phoneNumber,
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!dummyFormData.employeeName || !dummyFormData.email || !dummyFormData.phoneNumber) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Required Fields',
        text: 'Please fill all required fields before submitting.'
      });
      return;
    }     
      // Submit after state update
      handleFormSubmission(dummyFormData, formConfig);

  };
  
  


  useEffect(() => {
    try {
      const savedFormData = JSON.parse(localStorage.getItem("formData"));
      if (savedFormData) {
        setFormData((prev) => ({ ...prev, ...savedFormData }));
      }
    } catch (err) {
      console.error("Failed to parse formData from localStorage", err);
    }
  }, []);
  
  

  return (
    <div>
      {step === 1 && (
        <SrFixationForm1
          formData={formData}
          setFormData={setFormData}
          onFormDataChange={handleFormDataChange}
          onNext={handleNext}
          showTable={true}
        />
      )}
        {step === 2 && (
        <SrFixationForm2
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
        />
      )}
    {step === 3 && (
        <SrFixationForm3
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
        />
      )}

    {step === 4 && (
        <SrFixationForm4
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
        />
      )}

    {step === 5 && (
        <SrFixationForm5
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
        />
      )}

    {step === 6 && (
        <SrFixationForm6
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onSubmit={handleSubmit}
          visibleFields={["fixationTillDate"]}
        />
      )}

  
    {PaymentWindowComponent}

    </div>
  );
};

export default SrScaleFixation;
